var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.title)?_c('h3',{staticClass:"ag-block__title"},[(_vm.url)?_c('a',{attrs:{"href":_vm.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.title))]):_c('span',[_vm._v(_vm._s(_vm.title))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }